module.exports = __webpack_public_path__ + "img/btn_HIGH_win.b5ddadbc.png";